import { apiClient } from 'api'
import { Position } from 'types'

type NewItem = Omit<Position, 'id'>

export const getPositions = () => apiClient.get<Position[]>('/positions')

export const getPositionById = (positionId: number) => apiClient.get<Position>(`/positions/${positionId}`)

export const createPosition = (position: NewItem) => apiClient.post<NewItem, Position>('/positions', position)

export const editPosition = (position: Position) => apiClient.patch<Position>(`/positions/${position.id}`, position)

export const deletePosition = (id: number) => apiClient.delete(`/positions/${id}`)
